import { render, staticRenderFns } from "./OrgSettingsDocuments.vue?vue&type=template&id=a5004b8a&scoped=true&"
import script from "./OrgSettingsDocuments.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsDocuments.vue?vue&type=style&index=0&id=a5004b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5004b8a",
  null
  
)

export default component.exports